// extracted by mini-css-extract-plugin
export default {"wrapper":"MonthSelectorInput_wrapper__hC80B","input":"MonthSelectorInput_input__EyqNw"};